import { Typography, makeStyles, Box } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: '#FDECEA',
    borderRadius: '8px',
    padding: '14px 16px',
    alignItems: 'center',
  },
  icon: {
    color: '#D32F2F',
    marginRight: '12px',
  },
  title: {
    fontWeight: 'bold',
    color: '#B71C1C',
  },
  description: {
    color: '#B71C1C',
  },
}));

export const PortalMessageFor3MLoans = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <ErrorOutlineIcon className={classes.icon} />
      <Box>
        <Typography className={classes.title} variant="body1">
          Please be aware that due to recent market changes, we are not lending on loan amounts over $3M at this time.
        </Typography>
        <Typography className={classes.description} variant="body2">
          Please speak to your relationship manager if you have any questions.
        </Typography>
      </Box>
    </Box>
  );
};
